import { useEffect, useState } from "react";

/**
 * The popup landing page for the Google OAuth redirect. It runs in a separate
 * window opened by `runOAuthFlow` (lib/google-oauth), reads `code`/`state` (or
 * `error`) off the query string, posts them back to the opener, and closes.
 * Intentionally OUTSIDE the app Shell so it doesn't boot storage/stores.
 */
export function OAuthCallback() {
  const [message, setMessage] = useState("Finishing sign-in…");

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const payload = {
      source: "google-oauth-callback" as const,
      code: q.get("code") ?? undefined,
      state: q.get("state") ?? undefined,
      error: q.get("error_description") ?? q.get("error") ?? undefined,
    };
    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
      window.close();
      // If the browser refuses to close a script-opened tab, leave a note.
      setMessage("You can close this window.");
    } else {
      setMessage("This page is only used during Google sign-in. You can close it.");
    }
  }, []);

  return (
    <div style={{ fontFamily: "var(--app-font-family)", fontSize: "calc(14px * var(--app-text-scale))", padding: 24, color: "#444" }}>
      {message}
    </div>
  );
}
